import { Dialog } from '@material-ui/core';
import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';
import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

const MedalCellRenderer = ({ value, ...other }: any): HTMLElement => {
  // const handleReset = useCallback(async () => {
  //   console.log('test');
  // }, []);

  const handleReset = (value2: any) => {
    console.log('value2', value2);
  };

  // const ImageRender = (value2: any) => {
  //   console.log('props', value2);
  //   return (
  //     <button type="button" onClick={handleReset} onKeyDown={handleReset}>
  //       <img src={value2} alt="" />
  //     </button>
  //   );
  // };
  // useEffect(() => {
  //   ImageRender(value);
  // }, []);

  console.log('value', value);
  const imgSrc = document.createElement('img');
  imgSrc.setAttribute('src', value);
  imgSrc.setAttribute(
    'style',
    'width: auto; height: auto; max-width: 200px; max-height: 150px;'
  );
  // testa.onclick = () => {
  //   handleReset(value);
  // };

  imgSrc.onclick = () => {
    const newWindow = window.open('', '', 'width=500,height=500');
    if (newWindow) {
      const dialog = newWindow.document.createElement('dialog');
      dialog.setAttribute('open', 'true');
      dialog.addEventListener('close', () => newWindow.close());
      const img = newWindow.document.createElement('img');
      img.setAttribute('src', value);
      dialog.appendChild(img);
      newWindow.document.body.appendChild(dialog);
    }
  };

  // const node = <div>{ImageRender(value)}</div>;
  // const element = document.createElement('div');
  // element.innerHTML = ReactDOMServer.renderToStaticMarkup(node);
  // while (element.firstChild) {
  //   testa.appendChild(element.firstChild);
  // }
  return imgSrc;
};

export default MedalCellRenderer;
